// @ts-check
import React from 'react';

import CloudIcon from '@liquidweb-dev/undercurrent/icons/lucide/Cloud';
import Layers2Icon from '@liquidweb-dev/undercurrent/icons/lucide/Layers2';
import ServerIcon from '@liquidweb-dev/undercurrent/icons/lucide/Server';

/**
 * Icons determined by the `displayType` property from the `useAssetDetails` hook. Reminder: `displayType` requires the `alsowiths` of `altGroup`, `capabilities`, and `categories`.
 * @param {import('@liquidweb-dev/undercurrent/SvgIcon').SvgIconProps & {
 *   displayType: import('modules/queries/asset/useDetails').AssetDetails['displayType'];
 * }} props
 */
const DisplayTypeIcon = ({ displayType, ...rest }) => {
	const displayTypeLowerCase = displayType.toLowerCase();

	if (displayTypeLowerCase.includes('vps')) {
		return <Layers2Icon {...rest} />;
	}

	if (displayTypeLowerCase.includes('cloud')) {
		return <CloudIcon {...rest} />;
	}

	return <ServerIcon {...rest} />;
};

export default DisplayTypeIcon;
